module.exports = __webpack_public_path__ + "static/chart-perahia.bf100f0b.jpg";


//////////////////
// WEBPACK FOOTER
// /tmp/build_2cb81483/src/assets/images/home/chart-perahia.jpg
// module id = 1346
// module chunks = 4